import { Divider, Tooltip, message } from 'antd';
import { useAuthorization } from 'components/Authorization';
import { useLechatAgentEnable } from 'hooks/business/useOrgConfig';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import useRoles from 'hooks/business/useRoles';
import chatttSDK from 'services/chattt';
import { useTranslate } from '@tolgee/react';
import { isInElectron } from 'utils/is';
import { openExternalURL } from 'utils/openExternalURL';
import lechatAgentIcon from './assets/lechatAgent.png';

export default function LechatAgentEntry() {
  const enabled = useLechatAgentEnable();
  const { isSuperviser } = useRoles();
  const { token } = useAuthorization<Oversea.Token.Payload>();
  const lang = useSystemLanguageValue();
  const { t } = useTranslate();

  if (!enabled || !isSuperviser) {
    return null;
  }

  const openWorkspace = () => {
    if (!token) {
      return;
    }

    const targetURL = new URL(import.meta.env.VITE_LECHAT_AGENT_URL);
    const hashParams = new URLSearchParams();
    hashParams.set('token', token);
    hashParams.set('lang', lang);
    targetURL.hash = hashParams.toString();
    const url = targetURL.toString();

    if (isInElectron) {
      if (!chatttSDK?.app?.openUrlBrowser) {
        message.error(t('header.lechatAgent.unsupported'));
        return;
      }
      void chatttSDK.app.openUrlBrowser(url, {
        title: t('header.lechatAgent.title'),
      });
      return;
    }

    void openExternalURL(url, '_blank');
  };

  return (
    <>
      <Tooltip title={t('header.lechatAgent.title')}>
        <button
          type="button"
          className="flex h-7 w-7 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent p-0 hover:bg-fill-2"
          aria-label={t('header.lechatAgent.open')}
          onClick={openWorkspace}
        >
          <img className="h-6 w-6 rounded-md" src={lechatAgentIcon} alt="" />
        </button>
      </Tooltip>
      <Divider type="vertical" />
    </>
  );
}
